import { Footer } from "flowbite-react";
import { Facebook, Gitlab, Twitter, Web } from "../../Icons/Icons";

export function MainFooter() {
  return (
    <Footer className="container mx-auto px-4 shadow-none h-20 bg-white">
      <p className="text-sm font-inter text-secondary1">© 2024 Dat-Track, LLC. All rights reserved.</p>
      {/* <div className="flex items-center justify-start gap-2">
        <Facebook />
        <Twitter />
        <Gitlab />
        <Web />
      </div> */}
    </Footer>
  );
}
